export default {
      id: "ic-misc-search--old-usage",
      viewBox: "0 0 15 15",
      url: "../dist/images/" + "sprite.svg#ic-misc-search--old-usage",
      toString: function () {
        return this.url;
      }
    }